import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  EMPTY_FUNCTION,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { ICON_HEIGHT_16 } from '../../Icon'
import Text from '../../Text'
import {
  getGretaAIChatErrorTextKey,
  getIsGretaAIChatCriticalStatus,
} from '../GretaAIChat.utils'

import { QA_NAME_GRETA_AI_CHAT_HISTORY_RETRY } from './GretaAIChatAnswerError.constants'
import {
  getIsGretaAIChatAnswerErrorCleared,
  getIsGretaAIChatHistoryRetryable,
} from './GretaAIChatAnswerError.utils'

import * as styles from './GretaAIChatAnswerError.module.css'

import ErrorIcon from '../../../icons/error.svg'
import InfoIcon from '../../../icons/info.svg'
import RefreshIcon from '../../../icons/refresh.svg'

function GretaAIChatAnswerError({
  isFeedEmpty = false,
  isLimitReached = false,
  status,
  onReloadMessages = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  const isCleared = getIsGretaAIChatAnswerErrorCleared({
    isFeedEmpty,
    isLimitReached,
  })

  const textKey = isCleared ? null : getGretaAIChatErrorTextKey(status)
  const isCritical = getIsGretaAIChatCriticalStatus(status)
  const Icon = isCritical ? ErrorIcon : InfoIcon
  const canRetryHistory = getIsGretaAIChatHistoryRetryable({
    isFeedEmpty,
    status,
  })

  const rootClassName = classNames(styles.answerError, {
    [styles.critical]: isCritical,
    [styles.gapped]: !isFeedEmpty,
  })

  function handleReloadMessages() {
    onReloadMessages()
  }

  return textKey ? (
    <div className={rootClassName}>
      <Icon aria-hidden='true' className={styles.icon} />

      <Text
        Element='div'
        className={isCritical ? styles.criticalText : styles.text}
      >
        {t(textKey)}
      </Text>

      {canRetryHistory ? (
        <Button.Icon
          isGrey
          Icon={RefreshIcon}
          beforeIconProps={{ height: ICON_HEIGHT_16 }}
          className={styles.retry}
          height={BUTTON_HEIGHT_24}
          qaName={QA_NAME_GRETA_AI_CHAT_HISTORY_RETRY}
          tooltip={t('Greta.RetryButtonKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={handleReloadMessages}
        />
      ) : null}
    </div>
  ) : null
}

export default GretaAIChatAnswerError
